import React from 'react'

export default function Navbar() {
  return (
    <>
     <nav className="navbar sticky-top navbar-expand-lg bg-dark border-bottom border-body d-flex " data-bs-theme="dark">
  <div className="container-fluid d-flex ">
    <div>
    <a className="navbar-brand" href="#">WeSkill</a>
    </div>
    
    </div>
  
</nav>
    </>
  )
}
